import { Fragment, useState, useEffect } from "react";
import { Form, Input, Button, Select, message, notification } from "antd";
import { InputAntd } from "../../../components/commons";
import { updateOne } from "../../../api/participante";
import { WhatsAppOutlined } from "@ant-design/icons";
import {
  getFacultades,
  getOficinas,
  getCondicionesContrato,
  getDepartamentosAcademicos,
  getLugaresExamenes,
  getSemestres,
  getEspecialidades,
  getCarreras,
  getAsignaturas,
  getGradoAcademico
} from "../../../api/sistema";
import { openInNewTab } from "../../../utils/functions";
import * as SHARED from "../../../utils/shared";

const { Option } = Select;
const DNI = 1;
const CARNET_DE_EXTRANJERIA = 2;
const MAX_LENGTH_DNI = 8;
const MAX_LENGTH_CE = 12;
const REGEX_NUMBERS = "^[0-9]+$";
const REGEX_NUMS_AND_LETTERS = "^[a-zA-Z0-9]+$";

function ActualizarDatos(props) {
  const { participante, buttonsDisabled } = props;

  const [tipoDocumento, setTipoDocumento] = useState(DNI);

  // const [tiposDeParticipantes, setTiposDeParticipantes]=useState([{idtipoparticipante:"", nombre:""}])

  const [facultades, setFacultades] = useState([{ idfacultad: "", nombre: "" }]);

  const [oficinas, setOficinas] = useState([{ idoficina: "", nombre: "" }]);

  const [condicionesContrato, setCondicionesContrato] = useState([
    { idcondicioncontrato: "", nombre: "" }
  ]);

  const [departamentosAcademicos, setDepartamentosAcademicos] = useState([
    { iddepacademico: "", nombre: "" }
  ]);

  const [semestres, setSemestres] = useState([{ idsemestre: "", nombre: "" }]);

  const [especialidades, setEspecialidades] = useState([{ idespecialidad: "", nombre: "" }]);

  const [carreras, setCarreras] = useState([{ idcarrera: "", nombre: "" }]);

  const [asignaturas, setAsignaturas] = useState([{ isasignatura: "", nombre: "" }]);

  const [gradoAcademico, setGradoAcademico] = useState([{ idgradoacademico: "", nombre: "" }]);

   const [lugarExamen, setLugarExamen] = useState([{ idlugarexamen: "", nombre: "" }]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getFacultades();
      setFacultades(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getOficinas();
      setOficinas(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getCondicionesContrato();
      setCondicionesContrato(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getGradoAcademico();
      setGradoAcademico(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAsignaturas();
      setAsignaturas(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getDepartamentosAcademicos();
      setDepartamentosAcademicos(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
       const response = await getLugaresExamenes();
       setLugarExamen(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getSemestres();
      setSemestres(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getCarreras();
      setCarreras(response.payload);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const response = await getEspecialidades();
      setEspecialidades(response.payload);
    };
    fetchData();
  }, []);

  const prefixSelector = (
    <Form.Item name="tipoDocumento" noStyle initialValue={tipoDocumento}>
      <Select onSelect={(value) => setTipoDocumento(value)}>
        <Option value={DNI}>DNI</Option>
        <Option value={CARNET_DE_EXTRANJERIA}>C.E.</Option>
      </Select>
    </Form.Item>
  );

  const onFormSubmit = async (values) => {
    const formValues = values;
    // formValues.idtipoparticipante = 3
    formValues.idestado = participante.idestado;
    formValues.acceptTerms = true;
    delete formValues.tipoDocumento;
    delete formValues.idtipoparticipante;

    try {
      const res = await updateOne(formValues, participante._id);
      openNotificationWithIcon("success", res.message);
    } catch (err) {
      openNotificationWithIcon("error", err.message);
    }
  };

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message
    });
  };

  // console.log("especialidades", especialidades);

  const onFinishFailed = ({ values }) => {
    if (Number(values.nrodocumento) < 1) {
      message.error("Número de DNI no válido");
    }
  };

  return (
    <Form layout="vertical" onFinish={onFormSubmit} onFinishFailed={onFinishFailed}>
      <div className="md:flex">
        <Form.Item
          label="Apellidos"
          name="apellido"
          className="w-full md:w-1/2 md:mr-3"
          initialValue={participante ? participante.apellido : ""}
          rules={[{ required: true, message: "El apellido es necesario" }]}
        >
          <Input disabled={buttonsDisabled} />
        </Form.Item>
        <Form.Item
          label="Nombres"
          name="nombre"
          className="w-full md:w-1/2 md:ml-3"
          initialValue={participante ? participante.nombre : ""}
          rules={[{ required: true, message: "El nombre es necesario" }]}
        >
          <Input disabled={buttonsDisabled} />
        </Form.Item>
      </div>

      <div className="md:flex">
        <Form.Item
          label="Nro. de documento"
          name="nrodocumento"
          className="w-full md:w-1/2 md:mr-3"
          initialValue={participante ? participante.nrodocumento : ""}
          rules={[
            {
              required: true,
              message: "El campo nro. de documento es necesario"
            },
            {
              len: tipoDocumento === DNI && MAX_LENGTH_DNI,
              message: `La cantidad de dígitos debe ser ${MAX_LENGTH_DNI}`
            }
          ]}
        >
          <InputAntd
            disabled={buttonsDisabled}
            displayedValue={participante ? participante.nrodocumento : ""}
            maxLength={
              (tipoDocumento === DNI && MAX_LENGTH_DNI) ||
              (tipoDocumento === CARNET_DE_EXTRANJERIA && MAX_LENGTH_CE)
            } // dni: 8, ce: 12
            regex={
              (tipoDocumento === DNI && REGEX_NUMBERS) ||
              (tipoDocumento === CARNET_DE_EXTRANJERIA && REGEX_NUMS_AND_LETTERS)
            }
            addonBefore={prefixSelector}
            className="text-base h-9"
          />
        </Form.Item>

        <Form.Item
          // label="Número de celular"
          label={
            <p>
              Número de celular{" "}
              <Button
                size="small"
                disabled={!participante.nrocelular}
                onClick={() => openInNewTab("https://wa.me/51" + participante.nrocelular)}
              >
                <WhatsAppOutlined />
              </Button>
            </p>
          }
          name="nrocelular"
          className="w-full md:w-1/2 md:ml-3"
          initialValue={participante ? participante.nrocelular : ""}
          rules={[
            {
              required: true,
              message: "El número de celular es necesario"
            }
          ]}
        >
          <Input disabled={buttonsDisabled} />
        </Form.Item>
      </div>

      <div className="md:flex">
        <Form.Item
          label="Correo electrónico"
          name="email"
          className="w-full md:w-1/2 md:mr-3"
          rules={[
            {
              required: true,
              message: "El correo electrónico es necesario"
            }
          ]}
          initialValue={participante ? participante.email : ""}
        >
          <Input disabled={buttonsDisabled} />
        </Form.Item>

        {participante.idtipoparticipacion !== SHARED.ID_INTERNAMIENTO && (

        <Form.Item
          label="Lugar examen"
          name="idlugarexamen"
          className="w-full md:w-1/2 md:ml-3"
          initialValue={participante ? participante.idlugarexamen : ""}
          rules={[{ required: true, message: "El lugar de examen es necesario" }]}
        >
          <Select disabled={buttonsDisabled} placeholder="Seleccione lugar examen">
            {lugarExamen.map((item) => (
              <Option key={item.idlugarexamen} value={item.idlugarexamen}>
                {item.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>
        )}
      </div>

      <div className="md:flex">
        {participante.idtipoparticipante === SHARED.ID_DOCENTE && (
          <Fragment>
            <Form.Item
              label="Condición de contrato"
              name="idcondicioncontrato"
              className="w-full md:w-1/2 md:mr-3"
              initialValue={participante ? participante.idcondicioncontrato : ""}
            >
              <Select disabled={buttonsDisabled} placeholder="Seleccione la condición">
                {condicionesContrato.map((item) => (
                  <Option key={item.idcondicioncontrato} value={item.idcondicioncontrato}>
                    {item.nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Facultad"
              name="idfacultad"
              className="w-full md:w-1/2 md:ml-3"
              initialValue={participante ? participante.idfacultad : ""}
            >
              <Select disabled={buttonsDisabled} placeholder="Seleccione la facultad">
                {facultades.map((item) => (
                  <Option key={item.idfacultad} value={item.idfacultad}>
                    {item.nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Fragment>
        )}
      </div>

      <div className="">
        {participante.idtipoparticipante === SHARED.ID_ADMINISTRATIVO && (
          <Fragment>
            <div className="md:flex md:gap-4">
              <Form.Item
                label="Grado académico"
                name="idgradoacademico"
                initialValue={participante ? participante.idgradoacademico : ""}
                className="w-full md:w-1/2"
              >
                <Select disabled={buttonsDisabled} placeholder="Seleccione el grado académico">
                  {gradoAcademico.map((item) => (
                    <Option key={item.idgradoacademico} value={item.idgradoacademico}>
                      {item.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item
                label="Oficina / Dependencia"
                name="idoficina"
                className="w-full md:w-1/2"
                initialValue={participante ? participante.idoficina : ""}
              >
                <Select
                  disabled={buttonsDisabled}
                  placeholder="Seleccione la Oficina / Dependencia"
                  // defaultValue={participante ? participante.idoficina : ""}
                >
                  {oficinas.map((item) => (
                    <Option key={item.idoficina} value={item.idoficina}>
                      {item.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <Form.Item
              name="idcondicioncontrato"
              label="Condición de contrato"
              className="w-full md:w-1/2"
              initialValue={participante ? participante.idcondicioncontrato : ""}
            >
              <Select disabled={buttonsDisabled} placeholder="Seleccione la condición">
                {condicionesContrato.map((item) => (
                  <Option key={item.idcondicioncontrato} value={item.idcondicioncontrato}>
                    {item.nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <div className="md:flex">
              {participante.idtipoparticipacion === SHARED.ID_INTERNAMIENTO && (
                <Form.Item
                  label="Especialidad"
                  name="idespecialidad"
                  className="w-full md:w-1/2 md:mr-3"
                  rules={[{ required: true, message: "La especialidad es requerida" }]}
                  initialValue={participante ? participante.idespecialidad : ""}
                >
                  <Select disabled={buttonsDisabled} placeholder="Seleccione la condición">
                    {especialidades.map((item) => (
                      <Option key={item.idespecialidad} value={item.idespecialidad}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              )}
            </div>
          </Fragment>
        )}
        {participante.idtipoparticipante === SHARED.ID_ESTUDIANTE && (
          <Fragment>
            <Form.Item
              label="Código universitario"
              name="coduniversitario"
              className="w-full md:w-1/2 md:mr-3"
              initialValue={participante ? participante.coduniversitario : ""}
            >
              <Input placeholder="2017000000" disabled={buttonsDisabled} />
            </Form.Item>

            <Form.Item
              label="Facultad"
              name="idfacultad"
              initialValue={participante ? participante.idfacultad : ""}
              className="w-full md:w-1/2 md:ml-3"
            >
              <Select disabled={buttonsDisabled} placeholder="Seleccione la facultad">
                {facultades.map((item) => (
                  <Option key={item.idfacultad} value={item.idfacultad}>
                    {item.nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Fragment>
        )}
      </div>

      <div className="md:flex">
        {participante.idtipoparticipante === SHARED.ID_DOCENTE && (
          <Fragment>
            <Form.Item
              label="Departamento académico"
              className="w-full md:w-1/2 md:mr-3"
              name="iddepacademico"
              initialValue={participante ? participante.iddepacademico : ""}
            >
              <Select disabled={buttonsDisabled} placeholder="Seleccione el departamento">
                {departamentosAcademicos.map((item) => (
                  <Option key={item.iddepacademico} value={item.iddepacademico}>
                    {item.nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {participante.idtipoparticipacion === SHARED.ID_INTERNAMIENTO && (
              <Form.Item
                label="Asignatura de especialidad"
                className="w-full md:w-1/2 md:ml-3"
                name="idasignatura"
                initialValue={participante ? participante.idasignatura : ""}
              >
                <Select disabled={buttonsDisabled} placeholder="Seleccione la asignatura">
                  {asignaturas.map((item) => (
                    <Option key={item.idasignatura} value={item.idasignatura}>
                      {item.nombre}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            )}
          </Fragment>
        )}

        {participante.idtipoparticipante === SHARED.ID_ADMINISTRATIVO && (
          <Fragment>
            {/* <Form.Item
              label="Especialidad"
              name="idespecialidad"
              className="w-full md:w-1/2 md:mr-3"
              initialValue={participante ? participante.idespecialidad : ""}
              rules={[{ required: true, message: "La especialidad es requerida" }]}
            >
              <Select disabled={buttonsDisabled} placeholder="Seleccione la especialidad">
                {especialidades.map((item) => (
                  <Option key={item.idespecialidad} value={item.idespecialidad}>
                    {item.nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item> */}
          </Fragment>
        )}

        {participante.idtipoparticipante === SHARED.ID_ESTUDIANTE && (
          <Fragment>
            <Form.Item
              label="Semestre"
              name="idsemestre"
              className="w-full md:w-1/2 md:mr-3"
              initialValue={participante ? participante.idsemestre : ""}
            >
              <Select disabled={buttonsDisabled} placeholder="Seleccione el semestre">
                {semestres.map((item) => (
                  <Option key={item.idsemestre} value={item.idsemestre}>
                    {item.nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Escuela"
              name="idcarrera"
              className="w-full md:w-1/2 md:ml-3"
              initialValue={participante ? participante.idcarrera : ""}
            >
              <Select disabled={buttonsDisabled} placeholder="Seleccione la escuela">
                {carreras.map((item) => (
                  <Option key={item.idcarrera} value={item.idcarrera}>
                    {item.nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Fragment>
        )}
      </div>

      {/* {participante.idtipoparticipante === SHARED.ID_ESTUDIANTE && (
        
      )} */}

      {/* <Form.Item 
          name="idtipoparticipante" 
          label="Cargo a postular"
          rules={[{required:true, message:'El tipo de participante es requerido'}]}
          initialValue={participante ? participante.idtipoparticipante : ""}
        >
          <Select
            disabled={buttonsDisabled} 
            onChange={actualizarCamposFormulario}
            placeholder="Seleccione el tipo de participante"
            defaultValue={participante ? participante.idtipoparticipante : ""}
          >
            {tiposDeParticipantes.map((item)=> (
              <Option key={item.idtipoparticipante} value={item.idtipoparticipante}>
                {item.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item> */}

      {/* <div className="w-full">
        <Fragment>
          <p className="font-semibold">
            <span className="text-red-500 text-base font-bold">*</span> Fechas de participación
          </p>
          <div className="flex gap-4">
            <Form.Item
              name="participafecha1"
              valuePropName="checked"
              className=""
              initialValue={participante.participafecha1}
            >
              <Checkbox>01 DE MAYO</Checkbox>
            </Form.Item>

            <Form.Item
              name="participafecha2"
              valuePropName="checked"
              className=""
              initialValue={participante.participafecha2}
            >
              <Checkbox>08 DE MAYO</Checkbox>
            </Form.Item>
          </div>
        </Fragment>
      </div> */}

      <Form.Item
        name="directMessage"
        label="Mensaje a participante (SI SE LE MOSTRARÁ CUANDO ESTÉ OBSERVADO)"
        initialValue={participante ? participante.directMessage : ""}
      >
        <Input.TextArea
          rows={5}
          placeholder="Agrege un mensaje directo al supervisor respecto a los datos o archivos"
        />
      </Form.Item>

      <Form.Item
        name="observacion"
        label="Observación local (No se mostrará al participante)"
        initialValue={participante ? participante.observacion : ""}
      >
        <Input.TextArea
          rows={3}
          placeholder="Agrege una observación local respecto a los datos o archivos del participante, este no lo podrá leer"
        />
      </Form.Item>

      <Form.Item>
        <Button type="primary" block htmlType="submit">
          Guardar cambios
        </Button>
      </Form.Item>
    </Form>
  );
}
export default ActualizarDatos;
